import React from 'react';
import styled from 'styled-components';

const HeroContainer = styled.section`
  background-color: var(--light-bg);
  padding: var(--spacing-xxl) 0;
  position: relative;
  overflow: hidden;
`;

const HeroContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-lg);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-xl);
  align-items: center;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const HeroTextContent = styled.div`
  @media (max-width: 768px) {
    order: 2;
  }
`;

const HeroTitle = styled.h1`
  font-size: var(--font-size-5xl);
  margin-bottom: var(--spacing-lg);
  color: var(--primary-dark);
  line-height: 1.2;
  
  @media (max-width: 768px) {
    font-size: var(--font-size-4xl);
  }
`;

const HeroSubtitle = styled.p`
  font-size: var(--font-size-xl);
  margin-bottom: var(--spacing-xl);
  color: var(--text-secondary);
  line-height: 1.5;
  
  @media (max-width: 768px) {
    font-size: var(--font-size-lg);
  }
`;

const HeroActions = styled.div`
  display: flex;
  gap: var(--spacing-md);
  
  @media (max-width: 768px) {
    justify-content: center;
    flex-wrap: wrap;
  }
`;

const HeroImageContainer = styled.div`
  position: relative;
  
  @media (max-width: 768px) {
    order: 1;
    margin-bottom: var(--spacing-lg);
  }
  
  img {
    width: 100%;
    height: auto;
    border-radius: var(--border-radius-lg);
    box-shadow: var(--shadow-lg);
  }
`;

const HeroBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  
  &::before {
    content: '';
    position: absolute;
    top: -100px;
    right: -100px;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background-color: rgba(0, 180, 216, 0.1);
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: -150px;
    left: -150px;
    width: 400px;
    height: 400px;
    border-radius: 50%;
    background-color: rgba(0, 119, 182, 0.1);
  }
`;

const Hero = ({
  title,
  subtitle,
  actions,
  image,
  imageAlt = 'Hero image',
  background = true
}) => {
  return (
    <HeroContainer>
      {background && <HeroBackground />}
      
      <HeroContent>
        <HeroTextContent>
          <HeroTitle>{title}</HeroTitle>
          <HeroSubtitle>{subtitle}</HeroSubtitle>
          {actions && <HeroActions>{actions}</HeroActions>}
        </HeroTextContent>
        
        <HeroImageContainer>
          <img src={image} alt={imageAlt} />
        </HeroImageContainer>
      </HeroContent>
    </HeroContainer>
  );
};

export default Hero;
